export const Terms = () => {
    return (
        <main>
            <section className="container text-box">
                <h1>Terms of Use</h1>
                <p>
                    <strong>Effective date:</strong> 23 October 2025
                </p>

                <h2>1. Acceptance of Terms</h2>
                <p>
                    By accessing, downloading content from, or using this
                    website, you agree to these Terms of Use and our Privacy
                    Policy. If you do not agree, please refrain from using the
                    website.
                </p>

                <h2>2. Purpose of the Website</h2>
                <p>
                    This website is operated by
                    <strong>Functional Adjustment SRL</strong> to provide access
                    to digital design files, project documentation, and related
                    content, as well as to communicate updates about current and
                    future projects.
                </p>
                <p>
                    Certain content may be accessible only after email
                    verification or subscription.
                </p>

                <h2>3. License and Use of Digital Files</h2>
                <p>
                    Any downloadable files (including but not limited to STL or
                    CAD files) are provided for personal, non-commercial use
                    only, unless explicitly stated otherwise.
                </p>
                <p>You may:</p>
                <ul>
                    <li>Download and use the files for personal projects;</li>
                    <li>Modify the files for personal use;</li>
                    <li>
                        Create physical objects from the digital files for
                        personal use;
                    </li>
                </ul>
                <p>You may not:</p>
                <ul>
                    <li>
                        Resell, redistribute, or commercialize the digital files
                        or physical objects made from them;
                    </li>
                    <li>Claim the digital files as your own work;</li>
                    <li>
                        Use the files for commercial purposes without prior
                        written permission.
                    </li>
                </ul>
                <p>
                    All rights not expressly granted are reserved by{" "}
                    <strong>Functional Adjustment SRL</strong>.
                </p>

                <h2>4. Intellectual Property</h2>
                <p>
                    All content, logos, graphics, and design elements on this
                    website are owned by{" "}
                    <strong>Functional Adjustment SRL</strong> or its licensors
                    and is protected by applicable intellectual property laws,
                    except where specific usage rights are granted under Section
                    3.
                </p>
                <h2>5. Disclaimer</h2>
                <p>
                    All digital files and project instructions are provided “as
                    is” without warranties of any kind.
                </p>
                <p>You acknowledge and agree that:</p>
                <ul>
                    <li>
                        Results may vary depending on materials, printer
                        calibration, and assembly;
                    </li>
                    <li>
                        You are responsible for ensuring safe use, assembly, and
                        operation of any printed objects;
                    </li>
                    <li>
                        Functional Adjustment SRL is not responsible for
                        damages, injuries, or losses resulting from the use or
                        misuse of provided files or instructions.
                    </li>
                </ul>

                <h2>6. Limitation of Liability</h2>
                <p>
                    To the maximum extent permitted by law, Functional
                    Adjustment SRL shall not be liable for any indirect,
                    incidental, or consequential damages arising from the use or
                    inability to use the website, digital files, or related
                    content.
                </p>
                <h2>7. Access & Termination</h2>
                <p>
                    We reserve the right to modify, suspend, or terminate access
                    to the website or downloadable content at any time,
                    particularly in cases of misuse or violation of these Terms.
                </p>

                <h2>8. Governing Law and Jurisdiction</h2>
                <p>
                    These Terms are governed by and construed in accordance with
                    the laws of <strong>Romania</strong>. Any disputes shall be
                    resolved exclusively by the Romanian courts.
                </p>

                <h2>9. Contact</h2>
                <p>
                    For questions about these Terms, please contact us at{" "}
                    <a href="mailto:contact@tinkrverse.com">
                        contact@tinkrverse.com
                    </a>
                    .
                </p>
            </section>
        </main>
    );
};
